/** @jsxImportSource @emotion/react */
import ArrowRight from '~/icons/iconography/arrow/right.svg';
import { UmbracoTypes } from '~/lib/data-contract';
import { UmbracoImage } from '~/shared/components/Image';
import { Text } from '~/shared/components/Text';
import { VisuallyHidden } from '~/shared/components/VisuallyHidden';
import { weakKey } from '~/shared/utils/jsx';
import { ModuleContainer } from '~/templates/blocks/shared/ModuleContainer';
import { useModule } from '../../hooks/useModule';
import {
    StyledAction,
    StyledCategories,
    StyledCategory,
    StyledContent,
    StyledLink,
} from './styled';

export type M20CategoriesProps = UmbracoTypes.IM20CategoriesModule;

/**
 * List of category and/or page links, Can be used as display information without links.
 * The layout is supposed to be used with small illustrations or icons.
 */
export const M20Categories = ({ items, ...rest }: M20CategoriesProps) => {
    const { index } = useModule();

    return (
        <ModuleContainer hasGutter {...rest}>
            <StyledCategories>
                {items?.map((item) => (
                    <StyledCategory key={weakKey(item)}>
                        {item.image?.src ? (
                            <UmbracoImage
                                src={item.image.src}
                                alt={item.image.name ?? ''}
                                width={90}
                                height={90}
                                style={{ objectFit: 'contain' }}
                                priority={index < 2}
                            />
                        ) : null}
                        <StyledContent>
                            <Text css={{ fontWeight: 'bold' }}>{item.title}</Text>

                            {item.callToAction?.url ? (
                                <>
                                    <StyledLink href={item.callToAction.url} {...item.callToAction}>
                                        <VisuallyHidden>{item.title}</VisuallyHidden>
                                    </StyledLink>
                                    <StyledAction>
                                        {item.callToAction.text} <ArrowRight />
                                    </StyledAction>
                                </>
                            ) : null}
                        </StyledContent>
                    </StyledCategory>
                ))}
            </StyledCategories>
        </ModuleContainer>
    );
};
